import { render, staticRenderFns } from "./browse-gallery-modal.vue?vue&type=template&id=badd9a84&scoped=true&"
import script from "./browse-gallery-modal.vue?vue&type=script&lang=ts&"
export * from "./browse-gallery-modal.vue?vue&type=script&lang=ts&"
import style0 from "./browse-gallery-modal.vue?vue&type=style&index=0&id=badd9a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badd9a84",
  null
  
)

export default component.exports